import {addRemoveSalesUnitToClaim, addRemoveWarehouseUnitToClaim, clearClaim, commitInvoiceClaim, editClaim, editClaimItem, getInvoiceDetails} from "../../actions/history.js";
import {clearQuery, editQueryFilter, loadMoreSearchedProducts, prepareQueryOptions} from "../../actions/productQuery.js";
import {setDropDown, setModal} from "../../../common/actions/modal.js";

import HistoryClaimPage from "../../components/history/HistoryClaimPage.jsx";
import {connect} from "react-redux";
import {createBoundFunction} from "../../../common/util/reselect.js";
import {createFlowControl} from "../../../common/util/flowControl";
import {createLocalization} from "../../../common/util/localization.jsx";
import {scssVariables} from "../../../common/util/config.jsx";
import {setOrderProductView} from "../../actions/order.js";
import {withRouter} from "react-router-dom";

const mapStateToProps = () => {
    const flowControl = createFlowControl();
    return (state, ownProps) => ({
        startView: ownProps.match.params.view || "invoice",
        invoiceId: parseInt(ownProps.match.params.invoiceId || "0"),
        invoiceLines: state.history.invoices[parseInt(ownProps.match.params.invoiceId || "0")] && state.history.invoices[parseInt(ownProps.match.params.invoiceId || "0")].invoiceLines || [],
        listId: parseInt(ownProps.match.params.listId),
        localization: createLocalization(state),
        productView: state.order.productView,
        deviceType: state.view.deviceType,
        flowControl: flowControl,
        productQuery: state.productQuery,
        historyFilter: state.history.documents.filter,
        editingList: state.history.claim,
        productImage: state.productImage,
        width: state.view.innerWidth,
        deliveryDates: state.delivery.dates.deliveryDates || [],
        height: state.view.innerHeight-parseInt(scssVariables.menuHeight),
        productLists: state.productLists,
    });
};

const mapDispatchToProps = {
    setOrderProductView,
    loadMoreSearchedProducts,
    editQueryFilter,
    addRemoveSalesUnitToClaim,
    addRemoveWarehouseUnitToClaim,
    editClaim,
    editClaimItem,
    getInvoiceDetails,
    setModal,
    setDropDown,
    commitInvoiceClaim,
    prepareQueryOptions,
    clearClaim,
    clearQuery,
};

const myLoadMoreSearchedProducts = createBoundFunction();
const myEditQueryFilter = createBoundFunction();
const myCommitInvoiceClaim = createBoundFunction();

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    loadMoreSearchedProducts: myLoadMoreSearchedProducts((noOfProducts) => dispatchProps.loadMoreSearchedProducts(stateProps.productQuery, stateProps.productImage, noOfProducts, stateProps.startView == "invoice" ? stateProps.invoiceId : 0)),
    editQueryFilter: myEditQueryFilter( (change) => dispatchProps.editQueryFilter(stateProps.productQuery, stateProps.productImage, change, 
        myLoadMoreSearchedProducts((noOfProducts) => dispatchProps.loadMoreSearchedProducts(stateProps.productQuery, stateProps.productImage, noOfProducts))
    )),
    commitInvoiceClaim: myCommitInvoiceClaim(() => dispatchProps.commitInvoiceClaim(ownProps.history, stateProps.invoiceId)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(HistoryClaimPage));